import axios from 'axios'
import base from '../../../base'
import resource from '../resource'

export default {
  submitData(_, payload) {
    const config = {
      method: 'post',
      url: resource,
      baseURL: base,
      data: payload
    }

    return axios(config)
  }
}
